function Iran({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1387)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M16 0C9.12061 0 3.25593 4.342 0.995239 10.4348H31.0049C28.7442 4.342 22.8795 0 16 0V0Z" fill="#A2001D"/>
        <path d="M16 32C22.8795 32 28.7442 27.658 31.0049 21.5652H0.995239C3.25593 27.658 9.12061 32 16 32Z" fill="black"/>
        <path d="M12.1739 14.9565C12.1652 14.9565 12.1566 14.9571 12.1479 14.9572V14.9565H9.08931C9.24437 14.3574 9.788 13.913 10.4348 13.913V11.826C8.51687 11.826 6.95656 13.3864 6.95656 15.3043V17.0087V17.0435H12.1479H12.1739C12.3657 17.0435 12.5217 17.1995 12.5217 17.3913V18.0869H5.56519V20.1739H14.6087V17.3912C14.6087 16.0487 13.5164 14.9565 12.1739 14.9565V14.9565Z" fill="#496E2D"/>
        <path d="M17.3913 18.0869V11.826H15.3043V20.1739H18.7826V18.0869H17.3913Z" fill="#496E2D"/>
        <path d="M24.3478 18.087V11.826H22.2609V18.087H21.5652V16.0001H19.4783V20.174H25.7391V18.087H24.3478Z" fill="#496E2D"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Iran;
